export default {
    root: {
        fontSize: 16,
    },
    
  };
  